{
  "Filter": "Filter",
  "Search": "Suche",
  "Alarms": "Alarme",
  "Warnings": "Warnungen",
  "Users": "Benutzer",
  "Coolers": "Kühlgeräte",
  "Active License": "Aktive Lizenz",
  "License Expired": "Lizenz abgelaufen",
  "Grace Period": "Nachfrist",
  "Tenant Users": "Mandanten-Benutzer",
  "Logout": "Abmeldung",
  "Profile Update": "Profilaktualisierung",
  "Change Passowrd": "Passwort ändern",
  "Change Email": "E-Mail ändern",
  "Dashboard": "Dashboard",
  "Manage": "Verwalten",
  "Rules": "Regeln",
  "License Expires On": "Lizenz läuft ab am",
  "Report": "Bericht",
  "Tenant List": "Mandanten-Liste",
  "Add Tenant": "Mandant hinzufügen",
  "Erp No": "ERP-Nr.",
  "Tenant": "Mandant",
  "License End Date": "Lizenzenddatum",
  "Tenant Email": "Mandanten-E-Mail",
  "ERP Number": "ERP-Nummer",
  "Maximum number of coolers": "Max. Anzahl von Kühlgeräten",
  "License Expiration": "Lizenzablaufdatum",
  "Tenant Details": "Mandanten-Details",
  "TENANT EMAIL": "MANDANTEN-E-MAIL",
  "COOLERS": "KÜHLGERÄTE",
  "Expire": "ABLAUF",
  "GEO LOCATION": "ORTUNGSDIENST",
  "ERP NO": "ERP-NR.",
  "UPDATE": "AKTUALISIERUNG",
  "Disable Tenant": "Mandant deaktivieren",
  "Move Coolers": "KÜHLGERÄTE BEWEGEN",
  "Do you really want to disable": "Möchten Sie wirklich deaktivieren",
  "Cooler List": "Kühlgeräteliste",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "Nur in Spalten KÜHLGERÄT, LAND, TAG/ALIAS suchen",
  "Cooler": "Kühlgerät",
  "Last Connected": "Zuletzt verbunden",
  "Country": "Land",
  "Tag/Alias": "Tag/Alias",
  "User Information": "Benutzerinformation",
  "Add New User": "Neue Benutzer hinzufügen",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "Nur in Spalten ROLLE, E-MAIL, ALARME ERSTELLEN, ZUGRIFF AUF suchen",
  "Role": "Rolle",
  "Email": "Per E-Mail erreichen Sie uns unter",
  "Create Alarms": "Alarme erstellen",
  "Access To": "Zugriff auf",
  "Add User Details": "Benutzerdetails hinzufügen",
  "Edit User Details": "Benutzerdetails bearbeiten",
  "All Countries Selected": "Alle Länder gewählt",
  "Yes": "Ja",
  "No": "Nein",
  "Alarm Information": "Alarminformation",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "Nur in Spalten UID, STATUS, KÜHLGERÄT, ORTUNGSDIENST, ALARMTYP, RESSOURCE suchen",
  "UID": "UID",
  "Geo Location": "Ortungsdienst",
  "Status": "Status",
  "Alarm Type": "Alarmtyp",
  "Rule": "Regel",
  "Resource": "Ressource",
  "Alarm Rules": "Alarmregeln",
  "Add New Rule": "Neue Regeln hinzufügen",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "Nur in Spalten ID, STATUS, ALARMNAME, SCHWEREGRAD suchen",
  "All": "Alle",
  "All Controller with Geo Location": "Alle Regler mit Ortungsdienst",
  "ID": "ID",
  "Alarm Name": "Alarmname",
  "Limit": "Grenze",
  "Severity": "Schweregrad",
  "BACK": "ZURÜCK",
  "Last Connected On": "Zuletzt verbunden am",
  "Resources Data": "Ressourcendaten",
  "Tag Name": "Tag-Name",
  "Update Tag or Alias Name": "Tag oder Aliasnamen aktualisieren",
  "Update": "Aktualisieren",
  "Export": "Exportieren",
  "DAY": "TAG",
  "WEEK": "WOCHE",
  "MONTH": "MONAT",
  "Loading latest telemetry data ... ": "Letzte Telemetriedaten werden geladen ... ",
  "Loading telemetry data ... ": "Telemetriedaten werden geladen ...",
  "No Data to display": "Anz. der anzuzeigenden Daten",
  "Resources": "Ressourcen",
  "Min": "Min.",
  "Max": "Max.",
  "Value": "Wert",
  "Timestamp": "Zeitstempel",
  "Save": "speichern",
  "Cancel": "Stornieren",
  "Save and Apply": "Speichern und anwenden",
  "Move": "Bewegung",
  "Add Alarm Details": "Alarmdetails hinzufügen",
  "Update Alarm Details": "Alarmdetails aktualisieren",
  "Controller": "Regler",
  "Limits": "Grenzen",
  "Notified To": "Gemeldet an",
  "Apply To": "Anwenden auf",
  "Max Distance": "Max. Entfernung",
  "Controller Name": "Reglername",
  "All Controller In": "Alle Regler in",
  "High": "Hoch",
  "Low": "Niedrig",
  "Parameter": "PAR.",
  "Select Controller": "Regler wählen",
  "Select Controllers": "Regler wählen",
  "Select Resource": "Ressource wählen",
  "Success Message": "Erfolgreiche Meldung",
  "Error": "Fehler",
  "Are you sure to Delete User?": "Möchten Sie den Benutzer wirklich löschen?",
  "User deleted successfully.": "Benutzer erfolgreich gelöscht.",
  "Invalid Email": "Ungültige E-Mail",
  "Email field should not be empty.": "Das Feld E-Mail darf nicht leer sein.",
  "Email entered is not a valid email.": "Die eingegebene E-Mail ist nicht gültig.",
  "Invalid Role": "Ungültige Rolle",
  "Select a role.": "Eine Rolle wählen.",
  "Updated successfully.": "Erfolgreich geupdated.",
  "added successfully.": "erfolgreich hinzugefügt.",
  "Error occurred while adding user, please try again.": "Es ist ein Fehler beim Hinzufügen eines Benutzers eingetreten, bitte nochmals versuchen.",
  "Invalid Controller": "Ungültiger Regler",
  "Select a Controller": "Einen Regler wählen",
  "Invalid Resource": "Ungültige Ressource",
  "Select a Resource": "Eine Ressource wählen",
  "Invalid Min Value": "Ungültiger Mindestwert",
  "Enter a valid Min Value.": "Einen gültigen Mindestwert eingeben.",
  "Invalid Max Value": "Ungültiger Höchstwert",
  "Enter a valid Max Value.": "Einen gültigen Höchstwert eingeben.",
  "Invalid Max Distance Value": "Ungültiger max. Entfernungswert",
  "Enter a valid Max Distance Value.": "Einen gültigen max. Entfernungswert eingeben.",
  "Invalid Notify Mail Ids": "Ungültige Mail-Meldungs-ID",
  "Enter valid mail Ids.": "Gültige Mail-ID eingeben.",
  "Select a valid controller in apply to section.": "Einen gültigen Regler in Anwenden auf Abschnitt wählen.",
  "Invalid Countries": "Ungültige Länder",
  "Select one or more countries apply to section.": "Ein oder mehrere Länder in Anwenden auf Abschnitt wählen.",
  "Invalid Rule Name": "Ungültiger Regelname",
  "Enter a valid rule name.": "Einen gültigen Regelnamen eingeben.",
  "added successfully": "erfolgreich hinzugefügt",
  "updated successfully": "Erfolgreich geupdated",
  "Error occurred while adding/updating Rule, please try again.": "Es ist ein Fehler beim Hinzufügen/Aktualisieren einer Regel eingetreten, bitte nochmals versuchen.",
  "Activated successfully": "Supprimé avec succès......",
  "Deactivated successfully": "Erfolgreich deaktiviert",
  "Deleted successfully.": "Erfolgreich gelöscht.",
  "Are you sure to Delete Rule?": "Möchten Sie die Regel wirklich löschen?",
  "Invalid TenantName": "Ungültiger Mandanten-Name",
  "Tenant Name field should not be empty.": "Das Feld Mandanten-Name darf nicht leer sein.",
  "Invalid ERP No": "Ungültige ERP-NR.",
  "ERP NO field should not be empty.": "Das Feld ERP-NR. darf nicht leer sein.",
  "Invalid CoolersCount": "Ungültige Kühlgerätezählung",
  "Please enter valid Coolers": "Bitte gültige Kühlgeräte eingeben",
  "Invalid Cooler Value": "Ungültiger Kühlgerätewert",
  "Enter a valid Cooler Number Value.": "Einen gültigen Kühlgerätewert eingeben.",
  "Invalid Expiry Date": "Ungültiges Ablaufdatum",
  "Please select Expiry Date": "Bitte Ablaufdatum wählen",
  "Tenant added successfully.": "Mandant erfolgreich hinzugefügt.",
  "Error occurred while adding tenant, please try again.": "Es ist ein Fehler beim Hinzufügen eines Mandanten eingetreten, bitte nochmals versuchen.",
  "Tenant Updated successfully.": "Mandant erfolgreich aktualisiert.",
  "Error occurred while updating tenant, please try again.": "Es ist ein Fehler beim Aktualisieren eines Mandanten eingetreten, bitte nochmals versuchen.",
  "Reports": "Berichte",
  "Search works on Erp No, Tenant, Geo Location only": "Wörter nur in Erp-Nr., Mandant und Ortungsdienst suchen",
  "Update Tenant": "Mandant aktualisieren",
  "Select Expiry License Date": "Lizenzablaufdatum wählen",
  "Registered Tenant": "Registrierte Mandanten",
  "Registered Users": "Registrierte Benutzer",
  "Users under Tenant": "Unter Mandant vorhandene Benutzer",
  "Renewal notification sent to Tenant": "Erneuerungsbenachrichtigungen an Mandant gesendet",
  "Number of coolers under Tenant": "Unter Mandant vorhandene Kühlgeräteanzahl",
  "Date": "Datum",
  "Choose Format": "Format wählen",
  "Generate Report": "Bericht erstellen",
  "Select": "Auswählen",
  "Active Alarms": "Aktive Alarme",
  "Associated Resources": "Verknüpfte Ressourcen",
  "Associated Users": "Verknüpfte Benutzer",
  "Coolers List": "Kühlgeräteliste",
  "Device": "Gerät",
  "User Device Information": "Benutzergerät-Information",
  "Mobile Name": "Mobil-Name",
  "Mobile Model": "Mobil-Modell",
  "Legal": "Rechtshinweis",
  "Privacy Policy": "Datenschutz-Bestimmungen",
  "Copyright": "Urheberrechte",
  "Are you sure to Delete ?": "Bist du sicher, das du das löschen möchtest?",
  "No Records found": "Keine Aufzeichnungen gefunden",
  "Billing Address": "Rechnungsadresse",
  "Search works on Email, Mobile Name, Mobile Model": "Die Suche funktioniert mit E-Mail, Handynamen und Handymodell",
  "No results found!": "Keine Ergebnisse gefunden!",
  "Select Country": "Land auswählen",
  "Start Date": "Anfangsdatum",
  "End Date": "Endtermin",
  "Select Start Date": "Wählen Sie Startdatum",
  "Select End Date": "Wählen Sie Enddatum",
  "Invalid Start Date": "Ungültiges Startdatum",
  "Invalid End Date": "Ungültiges Enddatum",
  "Invalid Controllers List": "Ungültige Controller-Liste",
  "Please wait report is getting ready for Download": "Bitte warten, der Bericht wird zum Download bereitgestellt",
  "downloadFaild": "Faild zum herunterladen",
  "format": "Format",
  "Controllers": "Controller",
  "Downloads in Progress": "Downloads in Bearbeitung",
  "Do you agree?": "Sind Sie einverstanden?",
  "All the files downloaded Successfully": "Alle Dateien erfolgreich heruntergeladen",
  "No files found": "Keine Dateien gefunden",
  "You have cancelled the Downloads": "Sie haben die Downloads abgebrochen",
  "Warning": "Warnung",
  "Driver Manager": "Treiber-Manager",
  "Driver File Name": "Name der Treiberdatei",
  "Uploaded By": "Hochgeladen von",
  "Uploaded On": "Hochgeladen am",
  "Commands": "Befehle",
  "Are you sure to Delete Driver?": "Möchten Sie den Treiber wirklich löschen?",
  "Please upload a valid file": "Bitte laden Sie eine gültige Datei hoch",
  "Driver file already exists": "Treiberdatei existiert bereits",
  "Are you sure you want to Overwrite?": "Möchten Sie wirklich überschreiben?",
  "Download Success!": "Download Erfolg!",
  "File Deleted Successfull": "Datei erfolgreich gelöscht",
  "Trying to upload a non verified driver": "Es wird versucht, einen nicht verifizierten Treiber hochzuladen",
  "Driver File Uploaded": "Treiberdatei hochgeladen",
  "File name should not be more than 50 characters": "Der Dateiname sollte nicht länger als 50 Zeichen sein",
  "Unit": "Einheit",
  "Coolers by Country": "Kühler nach Land",
  "Bad Request": "Ungültige Anforderung",
  "Invalid input fields": "Ungültige Eingabefelder",
  "Invalid Tag Name": "Ungültiger Tag-Name",
  "Enable/Disable": "Aktivieren deaktivieren",
  "Actions": "Aktionen",
  "Controller Model": "Controller-Modell",
  "Selected Resources Data": "Ausgewählte Ressourcendaten",
  "Last 24Hr": "Letzte 24 Stunden",
  "View Data": "Daten anzeigen",
  "Note: Maximum of 8 resources are allowed to view data": "Hinweis: Maximal 8 Ressourcen dürfen Daten anzeigen",
  "Get Data": "Daten bekommen",
  "Until": "Bis um",
  "Tag Updated Successfully": "Tag erfolgreich aktualisiert",
  "Add Tag Name..": "Tag-Namen hinzufügen ..",
  "Select Tenant": "Wählen Sie Mandant",
  "Tenant Disabled Successfully.": "Mieter erfolgreich deaktiviert.",
  "Cooler moved successfully.": "Kühler erfolgreich bewegt.",
  "Unknown error occurred, Please try again.": "Unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "No cooler/coolers availabe to move": "Kein Kühler / Kühler zum Bewegen verfügbar",
  "The target Tenant does not have enough space for the new coolers": "Der Zielmieter hat nicht genügend Platz für die neuen Kühler",
  "Tenant is not selected": "Mieter ist nicht ausgewählt",
  "Please select Tenant": "Bitte wählen Sie Mieter",
  "Select Countries": "Länder auswählen",
  "Country List": "Länderliste",
  "Controller List": "Controller-Liste",
  "Notified Email To": "Benachrichtigte E-Mail an",
  "Close": "Bewegung",
  "Disable": "Deaktivieren",
  "Note: Once disabled you can not enable again.": "Hinweis: Einmal deaktiviert, können Sie nicht mehr aktivieren.",
  "Delete  Rule": "Regel löschen",
  "Delete Device": "Gerät löschen",
  "Ok": "Ok",
  "Hi": "Hallo",
  "Commandes": "Befehle",
  "Access Restricted Notice!": "Hinweis auf eingeschränkten Zugriff!",
  "Your License has expired. Please Contact your Admin.": "Ihre Lizenz ist abgelaufen. Bitte kontaktieren Sie Ihren Admin.",
  "Online": "Online",
  "Offline": "Offline",
  "Total": "Gesamt",
  "Processing...": "Verarbeitung läuft...",
  "Request Process Successfully": "Anfrage erfolgreich",
  "Error occurred while processing request, please try again.": "Es ist ein Fehler beim Verarbeiten der Anfrage eingetreten, bitte nochmals versuchen.",
  "Menu": "Menu",
  "Device Groups": "Gerätegruppen",
  "HACCP Report": "HACCP Report",
  "Statistics": "Statistiken",
  "Device List": "Geräteliste",
  "All Devices": "Alle Geräte",
  "Search works on Device, Groups, Alarms, Country columns": "Die Suche funktioniert für die Spalten Geräte, Gruppen, Alarme, Länder",
  "Dongle UId": "Dongle UId",
  "Active": "Aktiv",
  "InActive": "Inaktiv",
  "Group(s)": "Gruppe(n)",
  "Device Details": "Gerätedetails",
  "View Value": "Wert anzeigen",
  "Group Name": "Gruppenname",
  "Device Name": "Gerätename",
  "Description": "Beschreibung",
  "Created Date (UTC)": "Erstellungsdatum (UTC)",
  "Added By": "Hinzugefügt durch",
  "Search works on Group Name, Description columns": "Die Suche funktioniert für die Spalten Gruppenname und Beschreibung",
  "Add Group Details": "Gruppendetails hinzufügen",
  "Edit Group Details": "Gruppendetails bearbeiten",
  "Name of the Group": "Gruppenname",
  "Create New Group": "Neue Gruppe erstellen",
  "Select Devices": "Geräte auswählen",
  "Group Information": "Gruppeninformation",
  "Add Description": "Beschreibung hinzufügen",
  "Device Count": "Gerätezähler",
  "Alarm Count": "Alarmzähler",
  "Device Status": "Gerätestatus",
  "Group Count": "Gruppenzähler",
  "Device by Group": "Gerät nach Gruppe",
  "Alarms By Device Status": "Alarme nach Gerätestatus",
  "Device Status Count": "Gerätestatus-Zähler",
  "Alarms By Devices Over Time": "Zeitabhängige Alarme nach Geräten",
  "Real Time": "Real Time",
  "Last 24 Hrs": "Letzte 24 Stunden",
  "Last Week": "Letzte Woche",
  "Last Month": "Letzter Monat",
  "Last 3 Months": "Letzte 3 Monate",
  "Last 1 Year": "Letztes 1 Jahr",
  "Last 6 Months": "Letzte 6 Monate",
  "Devices": "Geräte",
  "OEM": "OEM",
  "Name": "Name",
  "OEM\/Parent": "OEM\/Parent",
  "Create Users": "Benutzer erstellen",
  "Selected Countries": "Gewählte Länder",
  "Selected Devices": "Gewählte Geräte",
  "Enabled": "Aktiviert",
  "Disabled": "Deaktiviert",
  "Groups": "Gruppen",
  "Groups List": "Gruppenliste",
  "Select Groups": "Gruppe auswählen",
  "Telemetry": "Telemetrie",
  "Filters": "Filter",
  "Show Favorites": "Favoriten zeigen",
  "Favorites": "Favoriten",
  "Label": "Label",
  "Current Value": "Aktueller Wert",
  "Operations": "Vorgänge",
  "Read All": "Alles lesen",
  "Settings": "Einstellungen",
  "Set Value": "Wert einstellen",
  "Mobile UId": "Mobil UId",
  "Mobile OS | Version": "Mobil OS | Version",
  "Issued On": "Herausgegeben am",
  "Active Device(s)": "Aktives Gerät(e)",
  "In-active Device(s)": "Nicht aktives Gerät(e)",
  "Block User": "Benutzer blockieren",
  "Unblock User": "Benutzer freigeben",
  "Driver Upload": "Treiber-Upload",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "Die Suche funktioniert für die Spalten Treiber-Dateiname, Maske und Hochgeladen",
  "Add new report": "Neuen Bericht hinzufügen",
  "Report Name": "Berichtname",
  "Report Frequency": "Berichtfrequenz",
  "Daily": "Täglich",
  "Weekly": "Wöchentlich",
  "Monthly": "Monatlich",
  "Data Frequency": "Datenfrequenz",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Bericht löschen:",
  "Add Report": "Bericht hinzufügen",
  "Update Report Details": "Berichtdetails aktualisieren",
  "Select Data Frequency": "Datenfrequenz auswählen",
  "One time per day": "Einmal täglich",
  "Two times per day": "Zweimal täglich",
  "Three time per day": "Dreimal täglich",
  "Four times per day": "Viermal täglich",
  "Select Device": "Gerät auswählen",
  "Data Frequency is Mandatory": "Datenfrequenz ist obligatorisch",
  "Device is Mandatory": "Gerät ist obligatorisch",
  "Resource is Mandatory": "Ressource ist obligatorisch",
  " Notified to email is Mandatory": " E-Mail-Benachrichtigung ist obligatorisch",
  "Maximum 8 resources can be selected": "Maximal 8 Ressourcen können ausgewählt werden",
  "Invalid OEM": "OEM ungültig",
  "Select an OEM": "OEM auswählen",
  "User already exist": "Benutzer bereits vorhanden",
  "Email or Role is not valid": "E-Mail oder Funktion nicht gültig",
  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "Sie sind derzeit blockiert. Bitte kontaktieren Sie den Systemadministrator, um Detail zur erneuten Zugriffsfreigabe zu erhalten. <System Admin EMAIL ID>",
  "Invalid Device": "Gerät ungültig",
  "Invalid Group": "Gruppe ungültig",
  "Error Deleting Alarm Rule": "Fehler beim Löschen der Alarmregel",
  "Are you sure to Block ?": "Möchten Sie wirklich blockieren?",
  "Are you sure to Unblock ?": "Möchten Sie wirklich entsperren?",
  "Error downloading driver file": "Fehler beim Download der Treiberdatei",
  "Group deleted successfully": "Gruppe erfolgreich gelöscht",
  "Failed to delete group": "Löschen der Gruppe fehlgeschlagen",
  "Group created successfully": "Gruppe erfolgreich erstellt",
  "Group details updated successfully": "Gruppendetails erfolgreich aktualisiert",
  "Failed to create\/edit group": "Erstellen\/Bearbeiten der Gruppe fehlgeschlagen",
  "Group Name already exist": "Gruppenname bereits vorhanden",
  "Group Name already exist\/duplicate Group Name": "Gruppen bereits vorhanden\/Gruppenname duplizieren",
  "Model is not valid": "Modell nicht gültig",
  "Name\/Desc is not valid": "Name\/Beschreibung nicht gültig",
  "One\/More selcted device is invalid or the user doesn't have access": "Ein\/mehrere gewählte Geräte ist\/sind nicht gültig oder der Benutzer hat keinen Zugriff",
  "User has no access to the group": "Benutzer hat keinen Zugriff auf die Gruppe",
  "Failed to fetch data": "Abrufen der Daten fehlgeschlagen",
  "Error deleting file ": "Fehler beim Löschen der Datei ",
  "Error occurred while adding\/updating Report, please try again.": "Es ist ein Fehler beim Hinzufügen\/Aktualisieren eines Berichts eingetreten, bitte nochmals versuchen.",
  "Are you sure to Delete Report?": "Möchten Sie den Bericht wirklich löschen?",
  "Error Deleting Report": "Fehler beim Löschen des Berichts",
  "User has no access to the Haccp Report": "Benutzer hat keinen Zugriff auf den HACCP-Bericht",
  "Report name is not valid": "Berichtname nicht gültig",
  "Invalid Controller type": "Ungültiger Reglertyp",
  "Duplicate report name": "Berichtname duplizieren",
  "Support": "Unterstützung",
  "FAQ's": "FAQ",
  "Add OEM": "OEM hinzufügen",
  "History": "Geschichte",
  "Version": "Ersion",
  "v3.2": "v3.2",
  "Terms and Conditions": "Geschäftsbedingungen",
  "Search works on OID,OEM Name,OEM Description": "Die Suche funktioniert nach OID, OEM-Name und OEM-Beschreibung",
  "OEM Description": "OEM-Beschreibung",
  "OEM Name": "OEM-Name",
  "OID": "OID",
  "Home": "Heim",
  "Phone/Tablet": "Telefon/Tablet",
  "Export Json": "Json exportieren",
  "Map View": "Kartenansicht",
  "Count": "Zählen",
  "Added On": "Hinzugefügt",
  "Modbus slave ID": "Modbus Slave ID",
  "Controller Type Name": "Name Reglertyp",
  "Device Type": "Gerätetyp",
  "Groups Count": "Gruppenzähler",
  "Day": "Tag",
  "Hour": "Stunde",
  "Start": "Starten",
  "End": "Ende",
  "Poli": "Poli",
  "Mask": "Maske",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "Die Suche funktioniert für die Spalten Berichtname, Berichtfrequenz und E-Mail-Benachrichtigung",
  "Release": "Veröffentlichung",
  "PCH": "PCH",
  "Location": "Location",
  "Dsp Id": "Dsp Id",
  "Firmware Version": "Firmware-Version",
  "Device Metadata": "Geräte-Metadaten",
  "Alarms count by device's status": "Alarmzähler nach Gerätestatus",
  "Alarms count group by device's status and device": "Alarm-Gruppenzähler nach Gerätestatus und Gerät",
  "Alarm Count distribution over time": "Zeitabhängige Alarmzähler-Verteilung",
  "Alarm status count over time": "Zeitabhängiger Alarmzähler-Status",
  "Device by Controller Model": "Gerät nach Reglermodell",
  "Select columns": "Spalten auswählen",
  "columns selected": "Gewählte Spalten",
  "Favourites": "Favoriten"





}
